import React from "react";
import IconIndicator from "../iconComponents/Indicator";
import {formatDateTimeToZone} from "../common/Helpers";
import {connect, useSelector} from "react-redux";
import {respondToRegCompanyInvitation} from "../../actions/auth";

export function PersonRequest(props) {

const handleRespondToInvite = (response) => {
    props.respondToRegCompanyInvitation(props.person.id, response, {"Company Admin": props.roleCa, Creator: props.roleCreator});
}


const company = useSelector((state) => state.company.company.name)
    return (
        <div className="request flex-column space-btwn" >
            <div className="content1 multiline light-black" >
                <div className="iblock v-middle gap-right-xs" >
                    <IconIndicator pathClass="p-fill" height="12px" />
                </div>
                <h3 className="iblock">Allow {props.person.first_name} to join <span className="heavy">{company}</span> with the permissions below? </h3>
                <h4 className="light iblock" >&nbsp; {formatDateTimeToZone(props.person.date_created)}</h4>
            </div>
            <div className="flex-row flex-end">
                <button id="admit_teammate" className="btn pri iblock gap-right-xs" onClick={() => handleRespondToInvite("accept")} >Allow</button>
                <button id="reject_tm_admission" className="btn sec iblock " onClick={() => handleRespondToInvite("reject")} >Decline</button>
            </div>
        </div>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {respondToRegCompanyInvitation})(PersonRequest);